<template>
  <div>
    <component
      :is="dialog.dialogData.type === 'phone' ? BInputPhone : BInput"
      v-model="contact.text"
      :error-messages="getErrorMessages(v$.text)"
      :label="contactType.name"
      :placeholder="`Введіть ${contactType.name.toLowerCase()}`"
      @blur="v$.text.$touch()"></component>
    <b-select
      v-model="contact.typeId"
      :error-messages="getErrorMessages(v$.typeId)"
      :items="$directory.get(contactType.directory, contact.type)"
      :loading="$loading.isLoading(contactType.directory)"
      label="Тип"
      placeholder="Оберіть тип"
      @blur="v$.typeId.$touch()"
      @focus="$directory.fill(contactType.directory)"></b-select>
  </div>
</template>

<script>
import { BInput, BInputPhone } from 'best-modules/components'
import { reactive } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { useVuelidate } from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { fillDirectory } from '@/directory/index.ts'
import {
  contractorAddressCreate,
  contractorAddressUpdate,
  contractorEmailCreate,
  contractorEmailUpdate,
  contractorPhoneCreate,
  contractorPhoneUpdate,
} from '@/requests/contractor'

export default {
  name: 'Contact',
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const getContactType = () => {
      const types = {
        address: {
          name: 'Адреса',
          directory: 'addressTypes',
          request: {
            create: contractorAddressCreate,
            update: contractorAddressUpdate,
          },
        },
        phone: {
          name: 'Телефон',
          directory: 'phoneTypes',
          request: {
            create: contractorPhoneCreate,
            update: contractorPhoneUpdate,
          },
        },
        email: {
          name: 'Email',
          directory: 'emailTypes',
          request: {
            create: contractorEmailCreate,
            update: contractorEmailUpdate,
          },
        },
      }
      return types[props.dialog.dialogData.type]
    }
    const contactType = getContactType()

    const contact = reactive({
      text: null,
      typeId: null,
      contractorId: props.dialog.dialogData.contractorId,
    })
    if (props.dialog.action === 'update') {
      Object.assign(contact, props.dialog.dialogData.contact)
      contact.text =
        props.dialog.dialogData.contact[props.dialog.dialogData.type]
    }
    if (props.dialog.action === 'create') {
      fillDirectory(contactType.directory)
    }

    const rules = {
      text: {
        required,
        email: props.dialog.dialogData.type === 'email' ? email : {},
      },
      typeId: { required },
    }

    const v$ = useVuelidate(rules, contact)

    const submit = () => {
      const request = {
        typeId: contact.typeId,
        contractorId: props.dialog.dialogData.contractorId,
      }
      request[props.dialog.dialogData.type] = contact.text

      return props.dialog.action === 'create'
        ? contactType.request.create(request)
        : contactType.request.update(contact.id, request)
    }

    return { contact, submit, v$, contactType, BInputPhone, BInput }
  },
}
</script>
